<template>
  <img class="qrcode" :src="dataURL" alt="">
</template>

<script>
import qrcode from 'qrcode-generator';

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 10,
    },
    typeNumber: {
      type: Number,
      default: 0,
    },
    errorCorrectionLevel: {
      type: String,
      default: 'L',
    },
  },
  data() {
    return {
      dataURL: '',
    };
  },
  watch: {
    text() {
      this.draw();
    },
  },
  mounted() {
    this.draw();
  },
  methods: {
    draw() {
      if (this.text) {
        const qr = qrcode(this.typeNumber, this.errorCorrectionLevel);
        qr.addData(this.text);
        qr.make();
        this.dataURL = qr.createDataURL(this.size);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
